
import { Component, Vue } from "vue-property-decorator";
import Cabecalho from "./components/Cabecalho.vue";
import MenuLateral from "./components/MenuLateral.vue";
import Rodape from "./components/Rodape.vue";
import Loader from "./components/Loader.vue";
import Login from "./views/login/Login.vue";
import InstallPwaBanner from './components/InstallPwaBanner.vue';

@Component({
  components: {
    Cabecalho,
    MenuLateral,
    Rodape,
    Login,
    Loader,
    InstallPwaBanner,
  },
})
export default class App extends Vue {
  carregando = true;
  logado = false;
  status = "";
  menuMobileVisible = false;
  
  async created() {
    this.carregando = true;
    this.logado = !!this.$parse.usuarioLogado;
    if (this.logado) {
      await this.carregaDadosSistema();
    }
    this.carregando = false;
  }

  /**
   * Ao iniciar o app, carrega as informações do clube e do distrito do usuário logado.
   *
   * O app não será renderizado enquanto os parametros abaixo não forem carregados.
   */
  async carregaDadosSistema() {
    if (!this.logado) return;

    this.carregando = true;
    await Promise.all([
      this.$utils.getMeusDados(),
      this.$permissoes.carregaPermissoesUsuario(),
      this.$notificacao.carregaNotificacoes(),
    ]).catch(this.$notificacao.mensagemErro);
    this.carregando = false;
  }

  toggleMenu() {
    this.menuMobileVisible = !this.menuMobileVisible;
  }

  async logout() {
    this.status = "saindo...";
    this.carregando = true;
    await this.$parse.logOut();
    this.logado = false;
    this.status = "";
  }
}
